"use strict";
/** @jsx jsx */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const framer_motion_1 = require("framer-motion");
const constants_1 = require("@/constants");
const __1 = require("..");
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Accordion = ({ label, badgeLabel, onClick, children, open = false, isActive = false }) => (core_1.jsx("div", { className: styles_scss_1.default.accordionCont },
    core_1.jsx("div", { className: styles_scss_1.default.accordionTopSection, "aria-hidden": "true", onClick: onClick },
        core_1.jsx("div", { className: styles_scss_1.default.toggleCont },
            core_1.jsx("img", { src: open ? constants_1.Images.accordionAngleUp : constants_1.Images.accordionAngleDown, alt: "angle-down" }),
            core_1.jsx("label", { htmlFor: "#", css: styles_1.default.label({ isOpen: open }) }, label)),
        core_1.jsx("div", { className: styles_scss_1.default.badgeCont },
            core_1.jsx(__1.Badge, { label: badgeLabel, variant: isActive ? "primary" : "tertiary" }))),
    core_1.jsx(framer_motion_1.AnimatePresence, { initial: false }, open && (core_1.jsx(framer_motion_1.motion.section, { key: "content", initial: "collapsed", animate: "open", exit: "collapsed", variants: {
            open: { opacity: 1, height: "auto" },
            collapsed: { opacity: 0, height: 0 }
        }, transition: { duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] } }, children)))));
Accordion.defaultProps = {
    badgeLabel: undefined,
};
exports.default = Accordion;
